module.exports = __webpack_public_path__ + "static/img/e8title.8782b23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/e8title.png
// module id = bg+K
// module chunks = 0